import Creatable from "react-select/creatable"; // replace Select with Creatable
import { CustomTheme } from "../styles/CustomTheme";

export const CustomSelect = ({
	value,
	onChange,
	onCreateOption,
	options,
	menuIsOpen,
	setMenuIsOpen,
}: any) => {
	const { colors } = CustomTheme;

	const customStyles = {
		control: (provided: any, state: any) => ({
			backgroundColor: "none",
			borderColor: state.isFocused ? colors.accent1 : colors.elevation1,
			borderWidth: "1px",
			// boxShadow: state.isFocused ? '0 0 0 1px #00A3E0' : 'none',
			borderRadius: 6,
			flex: 1,
			height: "2rem",
			minHeight: "1.5rem",
			display: "flex",
			fontSize: ".7rem",
			// justifyContent: 'center',
			alignItems: "center",
			"&:hover": {
				backgroundColor: colors.elevation3,
				color: colors.highlight3,
			},
		}),
		menu: (provided: any) => ({
			backgroundColor: "#1e1e1e",
			zIndex: 2,
		}),
		menuList: (provided: any, state: any) => ({
			...provided,
			padding: "6px",
			height: "fit-content",
			maxHeight: "200px",
			// "box-shadow":
			// 	"rgba(50, 50, 93, 0.746) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
			overflowY: "auto",
			"::-webkit-scrollbar": {
				width: "10px",
				height: "0px",
			},
			"::-webkit-scrollbar-track": {
				background: "transparent",
			},
			"::-webkit-scrollbar-thumb": {
				background: colors.elevation2,
			},
			"::-webkit-scrollbar-corner": {
				background: "transparent",
			},
		}),
		option: (provided: any, state: any) => ({
			...provided,
			height: "1.2rem",
			fontSize: ".7rem",
			textOverflow: "ellipsis",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			padding: "0px 10px",
			backgroundColor: state.isSelected ? colors.accent1 : "transparent",
			color: state.isSelected ? colors.highlight3 : colors.highlight2,
			"&:hover": {
				backgroundColor: colors.elevation3,
				color: colors.highlight3,
			},
		}),
		// valueContainer: (provided: any) => ({
		// 	...provided,
		// 	padding: "0px 10px",
		// 	color: colors.highlight1,
		// }),
		input: (provided: any) => ({
			...provided,
			// padding: "0px 10px",
			color: "#dcdcdc",
		}),
		singleValue: (provided: any) => ({
			...provided,
			color: "#dcdcdc",
		}),
		menuPortal: (provided: any) => ({
			...provided,
			position: "fixed",
			zIndex: 2000, // Set a higher zIndex value
		}),
	};

	return (
		<div style={{ flex: "1" }} onClick={() => setMenuIsOpen(!menuIsOpen)}>
			<Creatable
				value={value}
				onChange={onChange}
				onCreateOption={onCreateOption} // use onCreateOption prop
				options={options}
				styles={customStyles}
				menuIsOpen={menuIsOpen}
				menuPortalTarget={document.body}
				placeholder={<div>Search or create</div>}
			/>
		</div>
	);
};
